import { render, staticRenderFns } from "./SvgLinkBtn.vue?vue&type=template&id=39ce7474&scoped=true&"
import script from "./SvgLinkBtn.vue?vue&type=script&lang=ts&"
export * from "./SvgLinkBtn.vue?vue&type=script&lang=ts&"
import style0 from "./SvgLinkBtn.vue?vue&type=style&index=0&id=39ce7474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce7474",
  null
  
)

export default component.exports